'use client';

import { c as _c } from "react/compiler-runtime";
import { isServer, QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: 1
      }
    }
  });
}
let browserQueryClient: QueryClient | undefined;
function getQueryClient() {
  if (isServer) {
    return createQueryClient();
  } else {
    browserQueryClient ??= createQueryClient();
    return browserQueryClient;
  }
}
export function QueryClientProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}